import { defineStore } from "pinia";
import { ref } from "vue";

export const useThemeStore = defineStore("themes", () => {
  const themeIndex = ref(2);
  const setThemeIndex = (value: number): void => {
    themeIndex.value = value;
    // location.reload()
  }
  return {
    themeIndex,
    setThemeIndex,
  };
}, {
  persist: true,
});
